import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
// i18n — singleton react-i18next. Side-effect import suffit (pas de
// Provider à monter). Doit être avant `<App />` pour que tout
// useTranslation() au mount trouve une instance prête.
import "./i18n";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
